import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"offset-y":""}},[_c(VBtn,{attrs:{"slot":"activator","icon":"","data-cy":"contact-comunication-actions"},slot:"activator"},[_c(VIcon,[_vm._v("more_vert")])],1),_c(VList,{staticClass:"contact-actions"},[(!_vm.isCallDisabled)?_c(VListTile,{attrs:{"data-cy":"call-contact"},on:{"click":function($event){_vm.handleMakeCall()}}},[_c(VListTileTitle,[_c('span',[_c(VIcon,[_vm._v("call")]),_vm._v("  Call Contact")],1)])],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }